import { Route, Routes } from "react-router-dom";
import styled from "styled-components/macro";
import { ROUTER_MAP } from "./RouterConfig";

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
`;

export default function App() {
  return (
    <AppWrapper>
      <Routes>
        <>
          {ROUTER_MAP.map((info) => (
            <Route path={info.path} element={info.element}></Route>
          ))}
        </>
      </Routes>
    </AppWrapper>
  );
}
